import React, { useEffect } from "react";
import NavbarClass from "../NavbarClass";
import { activateUser } from "../../actions/userActions";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import { unsubscribeUser } from "../../actions/userActions";
import { pageview } from "../../utils/googleAnalyticsUtils";

class Unsubscribe extends React.Component {
  // componentDidMount(){
  //   const token = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).token
  componentDidMount() {
    pageview('Unsubscribe');
    const token = this.props.match.params.token;
    const userId = this.props.match.params.userId;
  }
  render() {
    return (
      <div>
        {typeof this.props.loading == "undefined" || this.props.loading ? (
          <LoadingSpinner />
        ) : this.props.success ? (
          <div>Successfully unsubscribed</div>
        ) : (
          <div>Some error occured</div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.userUnsubscribeMail.loading,
    error: state.userUnsubscribeMail.error,
    message: state.userUnsubscribeMail.message,
    success: state.userUnsubscribeMail.success,
  };
};
export default connect(mapStateToProps, { unsubscribeUser })(Unsubscribe);
